import { ColumnType } from 'types/column';
import { DataPoolName } from 'dashboards/types/data_pool';

// Data pool metadata can also be fetched from Propel but that would
// require widening the access token scope for all users
export const DATA_POOLS: Record<
  DataPoolName,
  {
    columns: Array<{
      name: string;
      datatype: ColumnType;
    }>;
    // User facing name
    label: string;
  }
> = {
  DP_gateway_metrics: {
    columns: [
      { name: 'timestamp', datatype: 'TIMESTAMP' },
      { name: 'gateway_id', datatype: 'STRING' },
      { name: 'gateway_name', datatype: 'STRING' },
      { name: 'gateway_metric', datatype: 'JSON' },
    ],
    label: 'Gateway Metrics',
  },
  DP_event_metadata: {
    columns: [
      { name: 'timestamp', datatype: 'TIMESTAMP' },
      { name: 'source_id', datatype: 'STRING' },
      { name: 'source_type', datatype: 'STRING' },
      { name: 'source_name', datatype: 'STRING' },
      { name: 'deployment_id', datatype: 'STRING' },
      { name: 'deployment_name', datatype: 'STRING' },
      { name: 'gateway_id', datatype: 'STRING' },
      { name: 'gateway_name', datatype: 'STRING' },
      { name: 'pipeline_id', datatype: 'STRING' },
      { name: 'pipeline_name', datatype: 'STRING' },
      { name: 'node_id', datatype: 'STRING' },
      { name: 'node_type', datatype: 'STRING' },
      { name: 'event_type', datatype: 'STRING' },
      { name: 'metrics_tag', datatype: 'STRING' },
    ],
    label: 'Event Metadata',
  },
  DP_object_metadata: {
    columns: [
      { name: 'timestamp', datatype: 'TIMESTAMP' },
      { name: 'source_id', datatype: 'STRING' },
      { name: 'source_type', datatype: 'STRING' },
      { name: 'source_name', datatype: 'STRING' },
      { name: 'deployment_id', datatype: 'STRING' },
      { name: 'deployment_name', datatype: 'STRING' },
      { name: 'gateway_id', datatype: 'STRING' },
      { name: 'gateway_name', datatype: 'STRING' },
      { name: 'pipeline_id', datatype: 'STRING' },
      { name: 'pipeline_name', datatype: 'STRING' },
      { name: 'node_id', datatype: 'STRING' },
      { name: 'node_type', datatype: 'STRING' },
      { name: 'object_id', datatype: 'STRING' },
      { name: 'object_label', datatype: 'STRING' },
      { name: 'object_class', datatype: 'INT32' },
      { name: 'object_attributes', datatype: 'STRING' },
      { name: 'metrics_tag', datatype: 'STRING' },
    ],
    label: 'Object Metadata',
  },
  DP_node_metadata: {
    columns: [
      { name: 'timestamp', datatype: 'TIMESTAMP' },
      { name: 'source_id', datatype: 'STRING' },
      { name: 'source_type', datatype: 'STRING' },
      { name: 'source_name', datatype: 'STRING' },
      { name: 'deployment_id', datatype: 'STRING' },
      { name: 'deployment_name', datatype: 'STRING' },
      { name: 'gateway_id', datatype: 'STRING' },
      { name: 'gateway_name', datatype: 'STRING' },
      { name: 'pipeline_id', datatype: 'STRING' },
      { name: 'pipeline_name', datatype: 'STRING' },
      { name: 'node_id', datatype: 'STRING' },
      { name: 'node_type', datatype: 'STRING' },
      { name: 'node_meta', datatype: 'JSON' },
      { name: 'roi_label', datatype: 'STRING' },
      { name: 'line_label', datatype: 'STRING' },
      { name: 'metrics_tag', datatype: 'STRING' },
    ],
    label: 'Node Metadata',
  },
};
